import { Box } from '@mui/material';
import Image from 'components/elements/Image';
import ExplainerText from 'components/elements/ExplainerText';
import Headline6 from 'components/elements/Headline6';
import { useContext } from 'react';
import { translate } from 'utils/Translate';
import { AppContext } from 'contexts/AppContext';
import { getTranslatedProductTitle } from 'utils/general';
import Headline5 from 'components/elements/Headline5';

function PackageContents(props) {
    const { orderlines } = props;
    const { styleGuide } = useContext(AppContext);

    const amountProducts = orderlines.reduce((sum, ol) => sum + ol.quantity, 0);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, borderWidth: 0.5, borderStyle: 'solid', borderColor: styleGuide.color2, borderRadius: 4, padding: {xs: 2, sm: 4} }}>
            <Headline5>
                {translate('_PACKAGE_CONTENTS_TITLE_', 'Produkter i denne pakke')} ({amountProducts})
            </Headline5>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                {orderlines.map((orderLine) => (
                    <OrderItem key={orderLine.OrderLineID} orderLine={orderLine} />
                ))}
            </Box>
        </Box>
    );
}

function OrderItem(props) {
    const { styleGuide, langCode } = useContext(AppContext)
    const { orderLine } = props
    const productTitle = getTranslatedProductTitle(orderLine, langCode)

    return (
        <Box display={'flex'} flex={1} gap={{ xs: 2, sm: 3 }} minWidth={260} maxWidth={350}>
            <Box display={'flex'} gap={2}>
                <Image
                    style={{
                        height: 175,
                        width: 140,
                        borderWidth: 0.5,
                        borderStyle: 'solid',
                        borderColor: styleGuide.color2,
                        backgroundColor: styleGuide.color2,
                    }}
                    src={`url(${orderLine.imageUrl})`}
                />
            </Box>

            <Box display={'flex'} flexDirection={'column'} gap={1} justifyContent={'space-between'} flex={1}>
                <Box style={{ display: 'flex', flexDirection: 'column', gap: { xs: 4, sm: 10 } }}>
                    <Headline6 fallbackText={orderLine.manufacturer || ' '} />
                    <ExplainerText fallbackText={productTitle || orderLine.orderlineTitle} />
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                        {orderLine.variationTitle &&
                            <ExplainerText
                                fallbackText={orderLine.variationTitle}
                            />
                        }
                    </Box>

                </Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <ExplainerText fallbackText={
                        <>
                            {translate('_QUANTITY_', 'Antal')}
                            <span>: {orderLine.quantity || '-'}</span>
                        </>
                    } />
                </Box>
            </Box>
        </Box>
    );
}

export default PackageContents;